.card {
    margin: 16px;
}

.cardBody {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    text-align: center;
}

.logo {
    width: 80%;
    display: block;
    margin-left: auto;
    margin-right: auto;
}

.heading {
    width: 100%;
    margin-top: 1rem;
}

.friendCode {
    font-size: 1.5rem;
    font-weight: bold;
    margin-top: 1rem;
}

.copyButton {
    background: linear-gradient(90deg, #fe911c 0%, #bb6701 100%);
    color: #fff;
    border: none;
    border-radius: 8px;
    padding: 0.6em 1.4em;
    font-size: 1rem;
    font-weight: 500;
    cursor: pointer;
    box-shadow: 0 2px 8px rgba(79, 140, 255, 0.15);
    transition: background 0.2s, transform 0.1s;
    outline: none;
}

.copyButton:hover,
.copyButton:focus {
    background: linear-gradient(90deg, #ec920b 0%, #d97b00 100%);
    transform: translateY(-2px) scale(1.04);
}

.copyButton:active {
    background: #357ae8;
    transform: scale(0.98);
}